export function imagesSlider() {
    let slider = $('.images-slider');
    slider.slick({
        infinite: false,
        cssEase: 'ease-in-out',
        dots: false,
        prevArrow: '.slider-prev',
        nextArrow: '.slider-next',
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 9999,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true
                }
            },
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/imagesSlider.js